<template>
	<AnemicButton v-if="isWorkflowShareable" class="share-button-container" @click.prevent="openShareModuleDialog" tile :disabled="!canShare">
		<slot />
	</AnemicButton>
</template>

<script>
import { mapGetters } from 'vuex';
import WorkflowService from '@/utils/WorkflowService';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { getWorkflow } from '@/store/modules/workflows/getters';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { FlowType, ProjectPermissions, ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'ShareButton',
	props: {
		workflowId: { type: Number },
	},
	computed: {
		...mapGetters([getWorkflow.fullPath, projectHasPermission.fullPath]),
		workflow() {
			return this[getWorkflow.fullPath](this.workflowId);
		},
		canShare() {
			return !!this.workflow?.current_version && this.workflow?.is_published && this.hasSharePermissions;
		},
		workflowTypeIconName() {
			if (this.workflow.flow_type === FlowType.Experience) {
				return this.integrationIconName(this.workflow);
			} else {
				return ServiceSlugs.Webhook; // 'tool-installation';
			}
		},
		hasSharePermissions() {
			return this[projectHasPermission.fullPath](this.workflow.project, ProjectPermissions.ChangeWorkflowUsers);
		},
		isWorkflowShareable() {
			return WorkflowService.isWorkflowShareable(this.workflow);
		},
	},
	methods: {
		integrationIconName(flowData) {
			return flowData.context_service_slug;
		},
		async openShareModuleDialog() {
			return AppDialogManagerService.openShareDialog({ workflowId: this.workflowId, canShare: this.canShare });
		},
	},
};
</script>

<style scoped lang="scss">
.share-button-container {
	height: 100%;
	min-width: 94px !important;
	border-radius: 6px !important;
	background: var(--bg-color) !important;
	border: 1px solid var(--share-button-border);

	font-size: 14px !important;
	font-weight: 300 !important;
	color: var(--primary-font-color) !important;
}
</style>
